import { Stack } from '@mui/material';
import { useAuth } from '@/shared/auth';
import { TIER_FEATURES, useGetSubscriptionPlans } from '@/entities/subscription';
import { toError } from '@/shared/lib/toError';
import { PlanHeroCard } from '../plan-status';
import { BillingHistoryTable } from '../billing-history';
import { TopPlanNote } from '../top-plan-note';
import { CancelSubscriptionRow } from '../cancel-subscription';
import { useOpenPortal } from '../manage-subscription';
import { findPlan } from '../model/findPlan';

type Props = {
  onPortalError: (error: Error) => void;
};

const ELITE_FEATURE_KEYS = TIER_FEATURES.elite.map((feature) => `subscription.features.${feature}`);

export const EliteTierLayout = ({ onPortalError }: Props) => {
  const { sessionUser } = useAuth();
  const { data: plansData } = useGetSubscriptionPlans();
  const portalMutation = useOpenPortal();

  const plans = plansData?.plans ?? [];
  const elitePlan = findPlan(plans, 'elite');

  const handleManageBilling = () => {
    portalMutation.mutate(
      { data: {} },
      {
        onSuccess: (data) => {
          window.open(data.portalUrl, '_blank');
        },
        onError: (error) => {
          onPortalError(toError(error));
        },
      }
    );
  };

  return (
    <Stack spacing={3} sx={{ maxWidth: 1000 }}>
      <PlanHeroCard
        tier="elite"
        interval={sessionUser?.subscription.interval ?? null}
        nextBillingDate={sessionUser?.subscription.expiresAt ?? null}
        features={ELITE_FEATURE_KEYS}
        priceMonthly={elitePlan?.monthly?.amount}
        onManageBilling={handleManageBilling}
        manageBillingLoading={portalMutation.isPending}
      />

      <BillingHistoryTable emptyState="paid" />

      <TopPlanNote />

      <CancelSubscriptionRow onMutationError={onPortalError} />
    </Stack>
  );
};
